import Request from "@/services/request";
import {
  STOCK_CODE_VALIDATIONS,
  PREPARING_TIME_VALIDATE,
  STOCK_CODE_VALIDATE,
  CATALOG_PREPARING_TIME,
  CATEGORY_PRICE_LIMIT,
} from "@/utils/enum/endpoints";

const request = new Request();

export default {
  async validatePreparingTime(_, payload) {
    const { day, id } = payload;
    try {
      const { data } = await request.get(
        `${CATALOG_PREPARING_TIME}/${day}/${id}`,
        null,
        {
          baseURL: "/selleroffice/rest",
          headers: { Accept: "application/json" },
        }
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async validateStockCode(_, stockCode) {
    try {
      const { data } = await request.get(
        `${STOCK_CODE_VALIDATIONS}?stockCode=${stockCode}`,
        null
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async confirmPreparationTime(_, { preparationTime, categoryId }) {
    try {
      const res = await request.get(
        PREPARING_TIME_VALIDATE.replace(
          "{preparationTime}",
          preparationTime
        ).replace("{categoryId}", categoryId),
        null,
        {
          baseURL: "/selleroffice/rest",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async confirmStockCode(_, { stockCode }) {
    try {
      const res = await request.get(
        STOCK_CODE_VALIDATE.replace("{stockCode}", stockCode)
      );
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getPriceConfirmation(_, { categoryId, price }) {
    try {
      const res = await request.get(
        CATEGORY_PRICE_LIMIT.replace("{categoryId}", categoryId).replace(
          "{price}",
          price
        ),
        null,
        {
          baseURL: "/selleroffice/rest",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};
